"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpLink = exports.defaultDAManifestFileName = exports.defaultOpenApiOutputDir = exports.defaultOutputDir = void 0;
exports.defaultOutputDir = ".generated"; // The default compile files will be generated in appPackage/.generated
exports.defaultOpenApiOutputDir = "specs"; // The default openapi files will be generated in appPackage/.generated/specs
exports.defaultDAManifestFileName = "declarativeAgent.json"; // The default declarative agent manifest file name
exports.helpLink = "https://aka.ms/teamsfx-actions/typeSpec-compile";
//# sourceMappingURL=constants.js.map